let slickConfig = {
    autoplay: true
};

function onDocumentReady(){
    let slideshow = window.jQuery('.hero-slideshow');
    if(slideshow.find('.hero-image').length > 1){
        slideshow.slick(slickConfig);
    }
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
